import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { IQuoteInput, QuoteState } from '@nibtravel/shared/data-access/quote';
import {
  QuoteConfigState,
  QuoteConfigStateModel,
} from '@nibtravel/shared/data-access/quote-config';
import {
  IUiContextState,
  UiContextState,
} from '@nibtravel/shared/data-access/ui-context';
import {
  IPolicyHolderAgeConfig,
  IPolicyHoldersInput,
  QuoteType,
} from '@nibtravel/shared/util/models';

@Injectable({ providedIn: 'root' })
export class TravellerAgeSelector {
  @Selector([QuoteConfigState, QuoteState.homeCountry, QuoteState.quoteType])
  static policyHolderConfig(
    state: QuoteConfigStateModel,
    homeCountry: string | undefined,
    quoteType: QuoteType
  ): IPolicyHolderAgeConfig | undefined {
    return homeCountry
      ? state[quoteType].policyHolderAgeConfigsMap[homeCountry]
      : undefined;
  }

  @Selector([QuoteState.quoteInput])
  static policyHolders(quoteInput: IQuoteInput): IPolicyHoldersInput[] {
    return quoteInput.policyHolders;
  }

  @Selector([UiContextState])
  static travellerSelection(uiContextState: IUiContextState): string {
    return uiContextState.travellerAgeSelection || '';
  }
}
